export default "__VITE_ASSET__95b6a505__"